import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const Registration = ({
    registrationIdsSelected,
    onUpdateRegistrationIdSelected
}) => {
    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 'calc(15% - 15px)',
        maxWidth: 'calc(15% - 15px)'
    }

    const records = [
        {
            "id": 100,
            "constructorList": [
                {
                    "label": "",
                    "labelGrid": "ID",
                    "argument": 100,
                    "argumentAdvanced": null,
                    "presentationSequence": 10,
                    "field": "id",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "S",
                    "columnType": "checkbox",
                    "dataType": "number",
                    "visible": "S",
                    "visibleTitle": "N",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                },
                {
                    "label": "dsItem",
                    "labelGrid": "Descrição do item",
                    "argument": "Usuário",
                    "argumentAdvanced": null,
                    "presentationSequence": 20,
                    "field": "dsItem",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "N",
                    "columnType": "input",
                    "dataType": "varchar",
                    "visible": "S",
                    "visibleTitle": "S",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                }
            ]
        },
        {
            "id": 101,
            "constructorList": [
                {
                    "label": "",
                    "labelGrid": "ID",
                    "argument": 101,
                    "argumentAdvanced": null,
                    "presentationSequence": 10,
                    "field": "id",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "S",
                    "columnType": "checkbox",
                    "dataType": "number",
                    "visible": "S",
                    "visibleTitle": "N",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                },
                {
                    "label": "dsItem",
                    "labelGrid": "Descrição do item",
                    "argument": "Empresa",
                    "argumentAdvanced": null,
                    "presentationSequence": 20,
                    "field": "dsItem",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "N",
                    "columnType": "input",
                    "dataType": "varchar",
                    "visible": "S",
                    "visibleTitle": "S",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                }
            ]
        },
        {
            "id": 102,
            "constructorList": [
                {
                    "label": "",
                    "labelGrid": "ID",
                    "argument": 102,
                    "argumentAdvanced": null,
                    "presentationSequence": 10,
                    "field": "id",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "S",
                    "columnType": "checkbox",
                    "dataType": "number",
                    "visible": "S",
                    "visibleTitle": "N",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                },
                {
                    "label": "dsItem",
                    "labelGrid": "Descrição do item",
                    "argument": "Clientes",
                    "argumentAdvanced": null,
                    "presentationSequence": 20,
                    "field": "dsItem",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "N",
                    "columnType": "input",
                    "dataType": "varchar",
                    "visible": "S",
                    "visibleTitle": "S",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                }
            ]
        },
        {
            "id": 103,
            "constructorList": [
                {
                    "label": "",
                    "labelGrid": "ID",
                    "argument": 103,
                    "argumentAdvanced": null,
                    "presentationSequence": 10,
                    "field": "id",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "S",
                    "columnType": "checkbox",
                    "dataType": "number",
                    "visible": "S",
                    "visibleTitle": "N",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                },
                {
                    "label": "dsItem",
                    "labelGrid": "Descrição do item",
                    "argument": "Serviços",
                    "argumentAdvanced": null,
                    "presentationSequence": 20,
                    "field": "dsItem",
                    "mask": "",
                    "placeHolder": "",
                    "readOnly": "N",
                    "columnType": "input",
                    "dataType": "varchar",
                    "visible": "S",
                    "visibleTitle": "S",
                    "isMandatory": "N",
                    "structureType": "default",
                    "checked": "N",
                    "additionalParametersDTO": null
                }
            ]
        }
    ]

    return (
        <Panel
            titlePage='Cadastros gerais'
            style={userControlPanelStyle}
            canEdit={false}
            canNewRecord={false}
            canDelete={false}
            canViewCRUD={true}
            readOnly={true}
            recordsSelected={registrationIdsSelected}
            viewOnlyOneRecordCRUD={true}
            className={'main-modal'}
        >
            <LoadingIndicator loaded={records}>
                <PanelListDefault
                    onUpdateIdSelected={onUpdateRegistrationIdSelected}
                    idsSelected={registrationIdsSelected}
                    data={records}
                />
            </LoadingIndicator>
        </Panel>
    );
};

export default Registration;

